export default "__VITE_ASSET__567727b1__"